import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import ItemsView from './views/ItemsView.vue';
import AboutView from './views/AboutView.vue';
import ScanView from './views/ScanView.vue';

const routes: RouteRecordRaw[] = [
  { path: '/', name: 'items', component: ItemsView },
  // `/item/:slug` рендерит тот же ItemsView, но открывает модалку поверх.
  { path: '/item/:slug', name: 'item', component: ItemsView, props: true },
  { path: '/scan', name: 'scan', component: ScanView },
  { path: '/about', name: 'about', component: AboutView },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
